import React, { useState } from "react";
import { Button } from "antd";
import AddNewFilter from "./AddNewFilter";

export const UpdateFilter = ({ refetchSections, keysoading, uniqueKeys, tenantName, section, filter }) => {
	const [visible, setVisible] = useState(false);
	return (
		<>
			<Button
				style={{
					marginLeft: "10px"
				}}
				onClick={() => {
					setVisible(true);
				}}
			>
				Update
			</Button>
			{visible && (
				<AddNewFilter
					filter={filter}
					mode="Update"
					refetchSections={() => {
						refetchSections();
						setVisible(false);
					}}
					loading={keysoading}
					filterKeys={uniqueKeys}
					tenantName={tenantName}
					section={section}
				/>
			)}
		</>
	);
};

export default UpdateFilter;
